import { chartSliceActions } from './chartSlice';

export const chartActions = {
  ...chartSliceActions,
};
